import {
  AppBar,
  Container,
  Toolbar,
  IconButton,
  Typography,
} from "@mui/material";

import LogoIcon from "./Logo.js";

export default function ServingExampleAppBar() {
  return (
    <AppBar style={{ background: "#8c0404" }}>
      <Container maxWidth="xl" disableGutters>
        <Toolbar variant="dense" disableGutters>
          <IconButton>
            <LogoIcon sx={{ color: "white", height: "1.3em", width: "auto", pl: "0.3em" }} />
          </IconButton>
          <Typography
            variant="h6"
            fontFamily={"Titillium Web"}
            color="inherit"
            component="div"
          >
            {process.env.REACT_APP_APP_NAME.toUpperCase()} DEMO
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
